import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'

export class AddRmaLineUpload extends RmaRequest<string, never> {
  path: string
  override init: RequestInit = { method: 'POST' }

  constructor({ lineId, identifier }: { lineId: string, identifier: string }) {
    super()
    this.path = `account/rma/draft/upload/${lineId}/${identifier}/`
  }
}
